import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantUserService, AppDataService, StoreService } from 'app/services';
import { PartnerMartLocationsComponent, PartnerMartLocationsHoursComponent } from 'app/partner';
import { MerchantUserRolesEnum, LocationType, OperationHour, SpecialHour, LegalDocumentTypeEnum } from 'app/models';
import { Utils } from 'app/utils';
import moment from 'moment';
import { MerchantUploadDocumentTypeEnum } from '../../../../../merchant';

enum MenuTab {
    ChooseOptions = 1,
    Details = 2,
    Products = 3,
    Employees = 4,
    StoreHours = 5,
    Handoff = 6,
    LegalDocs = 7
}

enum BirRegistrationTypeEnum {
    None = 0,
    VAT = 1,
    PercentageTax = 2
}

@Component({
    selector: 'partner-mart-locations-store-create',
    templateUrl: './partner-mart-locations-store-create.component.html',
    styleUrls: ['./partner-mart-locations-store-create.component.scss',
        '../../../../../../../styles/sidebar.scss',
        '../../../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsStoreCreateComponent implements OnInit {
    public storeId: number = 0;
    @Input()
    set _storeId(value: number) {
        this.storeId = value;
    }

    public showCreateStoreSideBar: boolean = false;
    @Input()
    set _showCreateStoreSideBar(value: boolean) {
        this.showCreateStoreSideBar = value;
    }

    @Input() public partnerMartLocationsComponent!: PartnerMartLocationsComponent;

    @Output() changedShowCreateStoreSideBarEmit = new EventEmitter<boolean>();
    changedShowCreateStoreSideBar(increased: any) {
        this.changedShowCreateStoreSideBarEmit.emit(increased);
    }

    @ViewChild(PartnerMartLocationsHoursComponent, { static: false })
    private partnerMartLocationsHours?: PartnerMartLocationsHoursComponent;

    public loading: boolean = false;

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.ChooseOptions;
    public merchantUserRolesEnum = MerchantUserRolesEnum;

    public locationType = LocationType.LocationTypeList;

    public birRegistrationTypeEnum = BirRegistrationTypeEnum;

    public today: Date = new Date();

    public subTitle: string = '';
    public store: any = {
        Name: null, NameIsEmpty: false,
        AddressDetails: null, AddressDetailsIsEmpty: false,
        Address: null, AddressIsEmpty: false,
        City: null, CityIsEmpty: false,
        PostalCode: null, PostalCodeIsEmpty: false,
        ImageUrl: null, ImageUrlIsEmpty: false,
        StoreOperationHours: [],
        StoreSpecialHours: [],
        BIR2303DocumentImageUrl: null, BIR2303ImgIsEmpty: false,
        BIR2303DocumentIssueDate: null, BIR2303IssueIsEmpty: false,
        BIR2303DocumentExpirationDate: null, BIR2303ExpirationIsEmprt: false,
        BIR2303DocumentNumber: null, BIR2303NumberIsEmpty: false,
        BIR2303IsFilled: false,
        BusinessPermitDocumentImageUrl: null, BusinessPermitImgIsEmpty: false,
        BusinessPermitDocumentIssueDate: null, BusinessPermitIssueIsEmpty: false,
        BusinessPermitDocumentExpirationDate: null, BusinessPermitExpirationIsEmpty: false,
        BusinessPermitDocumentNumber: null, BusinessPermitNumberIsEmpty: false,
        BusinessPermitIsFilled: false,
        BirRegistrationType: BirRegistrationTypeEnum.None,
        RegisteredAgentTax: null
    };
    public arrayEmployeeManagers: any[] = [];
    public arrayEmployeeCashiers: any[] = [];
    public arrayEmployeePackers: any[] = [];

    public merchantEmployees: any;

    public operationHours: OperationHour[] = [new OperationHour()];
    public specialHours: SpecialHour[] = [new SpecialHour()];

    //Google maps autocomplete
    public geocoder!: google.maps.Geocoder;
    public addresses: any[] = [];
    private timer: number = 0;

    public isDisabledNextBtn: boolean = true;

    constructor(private messageService: MessageService, private merchantUserService: MerchantUserService,
        public appData: AppDataService, private storeService: StoreService) {
    }

    ngOnInit(): void {
        if (this.storeId > 0) {
            this.activeMenuTab = MenuTab.Details;
            this.getStore();
        }
    }

    cancel() {
        this.changedShowCreateStoreSideBar(false);
    }

    nextCreateStore(menuTab: MenuTab, subTitle: string) {
        this.activeMenuTab = menuTab;
        this.subTitle = subTitle;
    }

    changeActiveMenuTab(menuTab: MenuTab) {
        if (this.storeId > 0) {
            this.activeMenuTab = menuTab;
        }
    }

    nextActiveMenuTab(menu: MenuTab) {
        if (menu === MenuTab.Details) {
            this.activeMenuTab = MenuTab.Products;
        }
        else if (menu === MenuTab.Products) {
            this.activeMenuTab = MenuTab.Employees;
        }
        else if (menu === MenuTab.Employees) {
            this.activeMenuTab = MenuTab.StoreHours;
        }
        else if (menu === MenuTab.StoreHours) {
            this.activeMenuTab = MenuTab.Handoff;
        }
        else if (menu === MenuTab.Handoff) {
            this.activeMenuTab = MenuTab.LegalDocs;
        }
    }

    //Google maps autocomplete
    public search(event: any) {
        const query = event.query;
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: query }, (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                this.addresses = predictions ? predictions.map((prediction) => prediction.description) : [];
            } else {
                this.addresses = [];
            }
        });
    }

    public geocodeClick() {
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(() => {
            this.geocoder.geocode({ address: this.store.Address }, (results, status) => {
                if (status === 'OK') {
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            });
            this.timer = 0;
        }, 700);
    }

    public validateField() {
        if (this.activeMenuTab === MenuTab.Details) {
            this.store.NameIsEmpty = (!this.store.Name) ? true : false;
            this.store.AddressDetailsIsEmpty = (!this.store.AddressDetails) ? true : false;
            this.store.AddressIsEmpty = (!this.store.Address) ? true : false;
            this.store.CityIsEmpty = (!this.store.City) ? true : false;
            this.store.PostalCodeIsEmpty = (!this.store.PostalCode) ? true : false;

            if (this.store.Name && this.store.AddressDetails && this.store.Address && this.store.City && this.store.PostalCode) {
                this.isDisabledNextBtn = false;
            }
        } else if (this.activeMenuTab === MenuTab.LegalDocs) {
            this.store.BIR2303ImgIsEmpty = (!this.store.BIR2303DocumentImageUrl) ? true : false;
            this.store.BIR2303IssueIsEmpty = (!this.store.BIR2303DocumentIssueDate) ? true : false;
            this.store.BIR2303ExpirationIsEmprt = (!this.store.BIR2303DocumentExpirationDate) ? true : false;
            this.store.BIR2303NumberIsEmpty = (!this.store.BIR2303DocumentNumber) ? true : false;
            this.store.BIR2303IsFilled = !this.store.BIR2303ImgIsEmpty && !this.store.BIR2303IssueIsEmpty &&
                !this.store.BIR2303ExpirationIsEmprt && !this.store.BIR2303NumberIsEmpty;

            this.store.BusinessPermitImgIsEmpty = (!this.store.BusinessPermitDocumentImageUrl) ? true : false;
            this.store.BusinessPermitIssueIsEmpty = (!this.store.BusinessPermitDocumentIssueDate) ? true : false;
            this.store.BusinessPermitExpirationIsEmpty = (!this.store.BusinessPermitDocumentExpirationDate) ? true : false;
            this.store.BusinessPermitNumberIsEmpty = (!this.store.BusinessPermitDocumentNumber) ? true : false;
            this.store.BusinessPermitIsFilled = !this.store.BusinessPermitImgIsEmpty && !this.store.BusinessPermitIssueIsEmpty &&
                !this.store.BusinessPermitExpirationIsEmpty && !this.store.BusinessPermitNumberIsEmpty;

            this.isDisabledNextBtn = !this.store.BIR2303IsFilled || !this.store.BusinessPermitIsFilled ||
                this.store.BirRegistrationType === this.birRegistrationTypeEnum.None || this.store.RegisteredAgentTax === null;
        }
        else {
            this.isDisabledNextBtn = true;
        }
    }

    public getMerchantUsers(event: any, roleId: MerchantUserRolesEnum) {
        const query = event.query;
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(() => {
            const dto = {
                MerchantId: this.appData.authData.MerchantId,
                RoleId: roleId,
                UserName: query
            };

            this.merchantUserService.getMerchantUsersByMerchant(dto, this.messageService)
                .then(data => {
                    if (!data) {
                        return;
                    }

                    if (!data.Success) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    this.merchantEmployees = data.Users;
                })
                .catch(error => {
                });
        }, 700);
    }

    public clickMerchantEmployee(object: any, roleId: MerchantUserRolesEnum) {
        const foundEmployee = this.arrayEmployeeManagers.find(s => s.UserId === object.UserId);
        if (roleId === MerchantUserRolesEnum.StoreManager) {
            if (!foundEmployee) {
                this.arrayEmployeeManagers.push(object);
            }
        }
        else if (roleId === MerchantUserRolesEnum.Cashier) {
            if (!foundEmployee) {
                this.arrayEmployeeCashiers.push(object);
            }
        }
        else if (roleId === MerchantUserRolesEnum.Dispatcher) {
            if (!foundEmployee) {
                this.arrayEmployeePackers.push(object);
            }
        }
        this.assignStore(object.UserId, this.storeId);
    }

    public deleteMerchantEmployee(index: number, roleId: MerchantUserRolesEnum) {
        if (roleId === MerchantUserRolesEnum.StoreManager) {
            const obj = this.arrayEmployeeManagers[index];
            this.assignStore(obj.UserId, 0);
            this.arrayEmployeeManagers.splice(index, 1);
        }
        else if (roleId === MerchantUserRolesEnum.Cashier) {
            const obj = this.arrayEmployeeCashiers[index];
            this.assignStore(obj.UserId, 0);
            this.arrayEmployeeCashiers.splice(index, 1);
        }
        else if (roleId === MerchantUserRolesEnum.Dispatcher) {
            const obj = this.arrayEmployeePackers[index];
            this.assignStore(obj.UserId, 0);
            this.arrayEmployeePackers.splice(index, 1);
        }
    }

    public handleImageClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event, typeImage: string) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                if (typeImage === 'StoreImage') {
                    this.store.ImageUrl = e.target.result.toString();
                }
                else if (typeImage === 'DeliveryDetails') {
                    this.store.PickupImageUrl = e.target.result.toString();
                }
                else if (typeImage === 'BusinessPermitDocument') {
                    this.store.BusinessPermitDocumentImageUrl = e.target.result.toString();
                    this.validateField();
                }
                else if (typeImage === 'BIR2303Document') {
                    this.store.BIR2303DocumentImageUrl = e.target.result.toString();
                    this.validateField();
                }
            }
        };

        reader.readAsDataURL(file);
    }

    addOrUpdateStore() {
        if (this.activeMenuTab === MenuTab.Details || this.activeMenuTab === MenuTab.StoreHours || this.activeMenuTab === MenuTab.Handoff) {
            if (this.storeId > 0) {
                this.updateStore();
                this.nextActiveMenuTab(this.activeMenuTab);
            } else {
                this.createStore();
            }
        }
        else if (this.activeMenuTab === MenuTab.Products) {
            this.nextActiveMenuTab(this.activeMenuTab);
        }
        else if (this.activeMenuTab === MenuTab.Employees) {
            this.nextActiveMenuTab(this.activeMenuTab);
        }
        else if (this.activeMenuTab === MenuTab.LegalDocs) {
            this.sendLegalDocuments();
        }
    }

    assignStore(userId: number, storeId: number) {
        this.loading = true;
        const dto = {
            StoreId: storeId,
            MerchantUserId: userId
        };

        this.merchantUserService.assignStore(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    getStore() {
        this.loading = true;
        const dto = {
            StoreId: this.storeId
        };

        this.storeService.getStore(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    console.log(data.ErrorMessage);
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.store = data;
                this.storeFields();
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    createStore() {
        this.loading = true;

        const dto = {
            MerchantId: this.appData.authData.MerchantId,
            Name: this.store.Name,
            AddressDetails: this.store.AddressDetails,
            Address: this.store.Address,
            City: this.store.City,
            PostalCode: this.store.PostalCode,
            ImageUrl: this.store.ImageUrl,
            BIR2303DocumentImageUrl: this.store.BIR2303DocumentImageUrl,
            BIR2303DocumentIssueDate: moment(this.store.BIR2303DocumentIssueDate).format('YYYY-MM-DD'),
            BIR2303DocumentExpirationDate: moment(this.store.BIR2303DocumentExpirationDate).format('YYYY-MM-DD'),
            BIR2303DocumentNumber: this.store.BIR2303DocumentNumber,
            BusinessPermitDocumentImageUrl: this.store.BusinessPermitDocumentImageUrl,
            BusinessPermitDocumentIssueDate: moment(this.store.BusinessPermitDocumentIssueDate).format('YYYY-MM-DD'),
            BusinessPermitDocumentExpirationDate: moment(this.store.BusinessPermitDocumentExpirationDate).format('YYYY-MM-DD'),
            BusinessPermitDocumentNumber: this.store.BusinessPermitDocumentNumber,
            RegisteredAgentTax: this.store.RegisteredAgentTax,
            BirRegistrationType: this.store.BirRegistrationType
        };

        this.storeService.createStore(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.storeId = data.Id;
                this.store = data;
                this.storeFields();
                this.activeMenuTab = MenuTab.Employees;
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data saved successfully' });
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    updateStore() {
        if (!this.partnerMartLocationsHours) {
            console.error('partnerMartLocationsHours not found');
            return;
        }

        this.loading = true;

        // OperationHours
        this.operationHours = this.partnerMartLocationsHours.getOperationHours();
        this.store.StoreOperationHours = this.partnerMartLocationsHours.getOperationHoursDto();

        // SpecialHours
        this.specialHours = this.partnerMartLocationsHours.getSpecialHours();
        this.store.StoreSpecialHours = this.partnerMartLocationsHours.getSpecialHoursDto();

        this.store.TimeZoneOffSet = Utils.getTimezoneOffset();

        this.store.BIR2303DocumentIssueDate = moment(this.store.BIR2303DocumentIssueDate).format('YYYY-MM-DD');
        this.store.BIR2303DocumentExpirationDate = moment(this.store.BIR2303DocumentExpirationDate).format('YYYY-MM-DD');
        this.store.BusinessPermitDocumentIssueDate = moment(this.store.BusinessPermitDocumentIssueDate).format('YYYY-MM-DD');
        this.store.BusinessPermitDocumentExpirationDate = moment(this.store.BusinessPermitDocumentExpirationDate).format('YYYY-MM-DD');

        this.storeService.editStore(this.store, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.storeId = data.Id;
                this.store = data;
                this.storeFields();
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data saved successfully' });
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    storeFields() {
        if (this.store.MerchantUsers.length > 0) {
            this.store.MerchantUsers.forEach((obj: any) => {
                if (obj.RoleId === MerchantUserRolesEnum.StoreManager) {
                    this.arrayEmployeeManagers.push(obj);
                }
            });
        }

        // OperationHours
        this.operationHours = [];

        if (!this.store.OperationHourItems || !this.store.OperationHourItems.length) {
            this.operationHours.push(new OperationHour());
        }
        else {
            this.store.OperationHourItems.forEach((obj: any) => {
                this.operationHours.push({
                    SelectedDaysWeek: obj.DayOfWeeks,
                    SelectStartTime: new Date(obj.StartTime), SelectStartTimeIsEmpty: false,
                    SelectEndTime: new Date(obj.EndTime), SelectEndTimeIsEmpty: false,
                });
            });
        }

        // SpecialHours
        this.specialHours = [];

        if (!this.store.StoreSpecialHours || !this.store.StoreSpecialHours.length) {
            this.specialHours.push(new SpecialHour());
        }
        else {
            this.store.StoreSpecialHours.forEach((obj: any) => {
                const specialHour: SpecialHour = {
                    Title: obj.Title,
                    StartDate: new Date(obj.StartDate),
                    EndDate: new Date(obj.EndDate),
                    IsOpen: obj.IsOpen,
                    StoreSpecialHourTimes: []
                };

                if (!obj.StoreSpecialHourTimes || !obj.StoreSpecialHourTimes.length) {
                    specialHour.StoreSpecialHourTimes.push({
                        OpensAt: null,
                        ClosesAt: null
                    });
                }
                else {
                    obj.StoreSpecialHourTimes.forEach((time: any) => {
                        specialHour.StoreSpecialHourTimes.push({
                            OpensAt: new Date(time.OpensAt),
                            ClosesAt: new Date(time.ClosesAt)
                        });
                    });
                }

                this.specialHours.push(specialHour);
            });
        }
    }

    private sendLegalDocuments() {
        if (this.isDisabledNextBtn) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Fill all fields' });
        }
        this.updateStore();

        const dto = {
            StoreId: this.storeId,
            Documents: [
                {
                    DocumentImageUrl: this.store.BusinessPermitDocumentImageUrl,
                    DocumentIssueDate: this.store.BusinessPermitDocumentIssueDate,
                    DocumentExpirationDate: this.store.BusinessPermitDocumentExpirationDate,
                    DocumentNumber: this.store.BusinessPermitDocumentNumber,
                    DocumentTypeId: LegalDocumentTypeEnum.BusinessPermit
                },
                {
                    DocumentImageUrl: this.store.BIR2303DocumentImageUrl,
                    DocumentIssueDate: this.store.BIR2303DocumentIssueDate,
                    DocumentExpirationDate: this.store.BIR2303DocumentExpirationDate,
                    DocumentNumber: this.store.BIR2303DocumentNumber,
                    DocumentTypeId: LegalDocumentTypeEnum.BIR2303
                }
            ]
        };
        this.loading = true;

        this.storeService.updateStoreLegalDocs(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document upload complete'});

                this.loading = false;
                this.cancel();
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }
}
